import VisaoExecutivaGeralView from "../../components/gestaoOrcamentaria/VisaoExecutivaGeralView";
import { DEPARTAMENTOS_CUSTO_MAO_DE_OBRA } from "../../constants/departamentosOrcamento";

export default function VisaoExecutivaCustos() {
  return <VisaoExecutivaGeralView tituloModulo="Visão Executiva Custos" departamentos={DEPARTAMENTOS_CUSTO_MAO_DE_OBRA} />;
}
